module.exports = __webpack_public_path__ + "media/images/brand/github_link-38e1749038c3a15e64bbacda8188e3df.svg";